// extracted by mini-css-extract-plugin
module.exports = {"restrict":"legislation_restrictor-module__restrict--1WDf8","icon":"legislation_restrictor-module__icon--1QLoO"};